<template>
  <v-container id="session">
    <v-img :src="getLogo" :alt="getAlt" class="mx-auto my-0" max-width="450px"></v-img>
    <h1 v-if="isBO">Backoffice</h1>
    <router-view></router-view>
  </v-container>
</template>

<script>
    export default {
        name: "Session",
        methods: {
          isAlumnier(){
            return document.location.hostname.indexOf('alumnier') > -1
          },
        },
        computed: {
          getLogo() {
            return this.isAlumnier() ? '/static/Alumnier_logo.png' : '/static/Iceverg_logo.png';
          },
          getAlt() {
            return this.isAlumnier() ? 'Welcome to Alumnier' : 'Welcome to Iceverg';
          },
          isBO(){
            return document.location.hostname.indexOf('1cvrg') > -1
          }

        }
    }
</script>

<style scoped>
  #session{
    text-align: center;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Session.vue